import React, { useEffect, useState, isValidElement, Children } from 'react';
import { AxiosError } from 'axios';
import Header from '../../top/components/Header';
import Footer from '../../top/components/Footer';
import Facility from '@/features/facility/shared/types/Facility';
import getFacility from '@/features/facility/shared/api/getFacility';

type LayoutProps = {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
  const [facility, setFacility] = useState<Facility>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFacility();
        setFacility(response.data.facility);
      } catch (error: unknown) {
        if(error instanceof AxiosError) {
          console.error(error.message);
        }
      }
    };

    fetchData();
  }, []);

  type ChildProps = {
    facility?: Facility;
  };

  const childrenWithProps = Children.map(children, child => {
    if (isValidElement(child)) {
      return React.cloneElement(child as React.ReactElement<ChildProps>, {
        facility
      });
    }
    return child;
  });

  return (
    <React.Fragment>
      <Header facility={facility} />
        {childrenWithProps}
      <Footer />
    </React.Fragment>
  )
}

export default Layout;